import LocalizedStrings from 'react-localization';
import React from 'react';


const currentLanguages = {};
window.enabledLocales.map(locale => {
    const currentLocale = window["language_" + locale.key];
    currentLanguages[locale.key] = currentLocale; 
})


const StringsOfLanguage = new LocalizedStrings(currentLanguages);
export default StringsOfLanguage;
